import { assertAPIResponse } from "../../services/api-response";
import axiosInstance from "../../services/axiosInstance";
import handleAPIError from "../../services/toast";
import { axiosWithAbort } from "../../services/axiosWithAbort";
import {
  normalizeBlobAPIError,
  throwIfBlobContainsAPIData,
} from "../../services/blob-response";

const baseURL = axiosInstance.defaults.baseURL;

export const dataEntryAPI = {
  //////// 取得數據輸入列表
  async getDEList(requestBody, routeCat) {
    const response = await axiosWithAbort("getDEList", {
      method: "POST",
      url: `/api/${routeCat}/data_entry_list`,
      data: requestBody,
    });
    if (response === null) return null;
    return response.data.data;
  },

  ////////  biomass 數據輸入列表
  async getBiomassDEList(requestBody, routeCat) {
    const response = await axiosWithAbort("getBiomassDEList", {
      method: "POST",
      url: `/api/${routeCat}/data_entry_list/biomass`,
      data: requestBody,
    });
    if (response === null) return null;
    return response.data.data;
  },

  //////////  取得單位下拉式選單
  async unitOptionDataEntryAPI(id, scope, cat) {
    try {
      const response = await axiosInstance.get(
        `/api/${scope}/data_entry/dropdown_list/${id}`,
      );
      return response.data.data; // 返回 API 的資料
    } catch (error) {
      // handleAPIError(error, "Error fetching unit options data");
      console.error("Error fetching unit options data:", error);
      return null; // 失敗時回傳 null
    }
  },

  //////////  取得數據輸入單位提示與說明
  async DataEntryHintAPI(id, scope) {
    let response; // 確保 response 在 try 內可用
    try {
      response = await axiosInstance.get(`/api/${scope}/data_entry_hint/`, {
        params: { activityId: id },
      });

      return response.data.data; // 返回 API 的資料
    } catch (error) {
      // handleAPIError(error, "Error fetching unit options data");
      console.error("Error fetching unit options data:", error);
      return null; // 失敗時回傳 null
    }
  },

  //////// 設定數據輸入
  async setDE(activityDataId, requestBody, routeCat) {
    const response = await axiosInstance.put(
      `/api/${routeCat}/data_entry/${activityDataId}`,
      requestBody,
    );
    return response.data;
  },

  //////// 新增數據輸入
  async addDE(requestBody, routeCat) {
    const response = await axiosInstance.post(
      `/api/${routeCat}/`,
      requestBody,
    );
    return response.data;
  },

  ////////修改數據輸入
  async editDE(dataEntryItemId, requestBody, routeCat) {
    const response = await axiosInstance.put(
      `/api/${routeCat}/${dataEntryItemId}`,
      requestBody,
    );
    return response.data;
  },

  ///////刪除某一筆數據輸入
  async deleteDE(cat, companyId, dataEntryItemId) {
    const response = await axiosInstance.delete(
      `/api/${cat}/${companyId}/${dataEntryItemId}`,
    );
    return response.data;
  },

  //////取得佐證資料
  async ValidationFileAPI(dataEntryId, scope) {
    try {
      const response = await axiosInstance.get(
        `/api/${scope}/validation_file/${dataEntryId}`,
        {
          headers: {
            accept: "application/json",
          },
        },
      );

      // 根據 API 實際回傳結構調整
      let fileList = response.data.data || response.data || [];

      // 在這裡添加基礎URL到每個檔案的link屬性
      fileList = fileList.map((file) => ({
        ...file,
        path: `${baseURL}${file.path}`,
      }));

      console.log("Processed file list:", fileList);

      return fileList;
    } catch (error) {
      // handleAPIError(error, "ValidationFileAPI error");
      console.error("ValidationFileAPI error:", error);

      if (error.response) {
        console.error("Server response error:", error.response.data);
        console.error("Status code:", error.response.status);
      }
    }
  },

  //預覽word
  async PreviewWordFileAPI(link) {
    try {
      // 改用原生的 fetch 來處理，完美支援 blob: URL 與一般 HTTP URL
      const response = await fetch(link);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const arrayBuffer = await response.arrayBuffer();
      return arrayBuffer;
    } catch (error) {
      console.error("文檔預覽 API 調用出錯:", error);
      throw error; // 重新拋出錯誤給調用者
    }
  },
  //下載佐證檔案API
  async HandleDownloadFileAPI(fileLink) {
    try {
      const res = await axiosInstance.get(fileLink, {
        responseType: "blob",
        skipAuth: true,
      });
      return res.data;
    } catch (error) {
      // handleAPIError(error, "API 下載失敗");
      console.error("API 下載失敗:", error);
    }
  },

  //////// 新增/編輯佐證資料
  async SetValidationFileAPI(
    dataEntryId,
    companyId,
    modeId, // 多個檔案=1，zip=2
    filesId, // 如果該筆 dataEntryId 以前有上傳過檔案的話，要將檔案的 id 貼上
    files, // 檔案物件（File 或 File[]）
    scope,
  ) {
    const formData = new FormData();
    formData.append("companyId", companyId);
    formData.append("modeId", modeId);
    formData.append("filesId", filesId || "");

    // 處理檔案上傳
    if (Array.isArray(files)) {
      files.forEach((file) => {
        formData.append("files", file); // 多個檔案用同一個 key
      });
    } else if (files) {
      formData.append("files", files); // 單個檔案
    }

    try {
      const response = await axiosInstance.post(
        `/api/${scope}/upload-files/${dataEntryId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            // accept: "application/json",
            // 使用 multipart/form-data 時，不需要手動設定 Content-Type
            // 瀏覽器會自動設定正確的 boundary
          },
        },
      );
      assertAPIResponse(response);

      // 檢查回應是否成功
      if (response.status >= 200 && response.status < 300) {
        return response.data;
      } else {
        handleAPIError(null, { apiData: response.data });
        console.error("API returned error status:", response.status);
        return null;
      }
    } catch (error) {
      console.error("Error uploading validation file:", error);
      throw error;
    }
  },

  ////////下載數據輸入Excel
  async downloadDataEntryExcel(requestBody) {
    const selectedCategory = Number(requestBody.standardId) === 2
      ? requestBody.ghgCategory
      : requestBody.category;
    if (!selectedCategory?.trim() || selectedCategory === "all") {
      const message = "Data entry download supports a single category only. Please select one category.";
      const error = new Error(message);
      error.response = { data: { success: false, message } };
      throw error;
    }
    requestBody = { ...requestBody, isSummary: requestBody.isSummary ?? false };

    const CATEGORY_API_ROUTE = {
      "3_3": "/api/dataentryexcel/download_data_entry_cat3_3/",
      "3_4": "/api/dataentryexcel/download_data_entry_cat3_4/",
      "3_5": "/api/dataentryexcel/download_data_entry_cat3_5/",
    };

    const apiRoute =
      CATEGORY_API_ROUTE[requestBody.category] ??
      "/api/dataentryexcel/download_data_entry/";

    try {
      const response = await axiosInstance.post(apiRoute, requestBody, {
        responseType: "blob",
        timeout: 300000,
      });
      await throwIfBlobContainsAPIData(response);

      // 創建 Blob 物件
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // 創建下載連結
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      const contentDisposition = response.headers["content-disposition"];
      const matchFileName = contentDisposition.match(/filename="?([^"]+)"?/);
      link.href = downloadUrl;
      link.setAttribute("download", `${matchFileName[1]}`); // 設定下載的檔名
      document.body.appendChild(link);
      link.click(); // 自動點擊下載
      document.body.removeChild(link); // 下載後移除連結
      window.URL.revokeObjectURL(downloadUrl);

      return response;
    } catch (err) {
      // handleAPIError(err, "Error downloading Excel");
      console.error("Error downloading Excel", err);
      await normalizeBlobAPIError(err);
      throw err;
    }
  },

  ////////上傳Excel
  async uploadDataEntryExcel(formData) {
    try {
      const response = await axiosInstance.post(
        `/api/dataentryexcel/upload_data_entry_excel/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      return response?.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },

  //////// 設定單位 API
  async setUnit(scope, id, unit) {
    try {
      const response = await axiosInstance.put(
        `/api/${scope}/data_entry/${id}`,
        {
          dataUnitId: unit,
        },
      );
      return response.data;
    } catch (error) {
      console.error("Error setting data entry unit:", error);
      return null;
    }
  },
};
